class QuickViewModal extends HTMLElement {
    constructor() {
        super();
        this.modalContent = this.querySelector('.js-modal-content');
        this.modalContentWrapper = this.modalContent.closest('.modal-content');
        this.showMorebtn = this.modalContent.querySelector('a');

        document.addEventListener('click', (event) => {
            const button = event.target.closest('.js-quickview-btn')
            if (!button) return

            const modalHeading = this.modalContent.querySelector('h1')?.innerHTML
            if (button.getAttribute('data-product-title') !== modalHeading) {
                this.showModal(button)
            }
        })
    }

    showModal(opener) {
        const loader = document.querySelector('.js-quickview-loader');
        if (loader) window.Global.showLoader(loader);

        fetch(opener.getAttribute('data-product-url'))
            .then((response) => response.text())
            .then((responseText) => {
                const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
                this.initModal(this.productElement, opener, this.showMorebtn)

                this.preprocessHTML(this.productElement);
                HTMLUpdateUtility.setInnerHTML(this.modalContent, this.productElement.innerHTML);

                if (window.Shopify && Shopify.PaymentButton) {
                    Shopify.PaymentButton.init();
                }

                if (window.ProductModel) window.ProductModel.loadShopifyXR();

                this.preventVariantURLSwitching();

                window.pauseAllMedia();
            })
            .finally(() => {
                this.bindProductChangeCallbacks();
                if (this.modalContentWrapper) this.modalContentWrapper.classList.remove('h-600');
                let image = this.modalContent.querySelector('picture > img');
                if (image && !image.complete) {
                    image.addEventListener('load', () => {
                        if (loader) window.Global.hideLoader(loader);
                    })
                } else {
                    if (loader) window.Global.hideLoader(loader);
                }
                window.Global.addProductToRecentlyViewed()
            });
    }

    bindProductChangeCallbacks() {
        const swapProductUtility = this.querySelector('variant-selects')?.swapProductUtility;
        if (swapProductUtility) {
            swapProductUtility.addPreProcessCallback(this.preprocessHTML.bind(this));
            swapProductUtility.addPostProcessCallback(() => {
                this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
                this.bindProductChangeCallbacks();
            });
        }
    }

    preprocessHTML() {
        this.productElement.classList.forEach((classApplied) => {
            if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.preventVariantURLSwitching();
    }

    initModal(modal, opener, button) {
        modal.classList.add('quick-view')
        // const gallery = modal.querySelector('.js-product-gallery') || modal.querySelector('.gallery-wrapper')
        // const image = gallery.querySelector('[data-glide-el="track"] li') || gallery.querySelector('[data-slide-id]')
        const hideEls = modal.querySelectorAll('.quick-view-remove')
        const galleryOpeners = modal.querySelectorAll('[data-bs-toggle="modal"]')
        const infoSection = modal.querySelector('[id^="ProductInfo"]')

        if (galleryOpeners.length) {
            galleryOpeners.forEach((opener) => {
                opener.removeAttribute('data-bs-toggle')
                opener.style.cursor = "default"
            })
        }

        if (button) {
            button.href = opener.getAttribute('data-product-url')
            button.classList.remove('hidden')

            if (infoSection) infoSection.appendChild(button)
        }

        // if (image) {
        //     gallery.querySelector(`.js-gallery-thumbnails`).parentNode?.remove()
        //     gallery.replaceWith(image.firstElementChild || image.firstChild)
        // }
        hideEls.forEach((el) => {
            el.remove()
        })
    }

    preventVariantURLSwitching() {
        const variantPicker = this.productElement.querySelector('variant-selects');
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
    }

    preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
            element.dataset.originalSection = sectionId;
        });
    }
}

customElements.define('quick-view-modal', QuickViewModal);